import $ from "jquery"
import DHTMLPopupWithMoire from "./dhtml_popup_with_moire"
import messageResource from "./messageResource"
import {trim} from "./atUtils"

function BasicLightbox() {}


//this constants must be init in child classes;
BasicLightbox.prototype.exist_invalid_fields_message_key = null;
BasicLightbox.prototype.close_tab_confirmation_message_key = null;

BasicLightbox.prototype = _.create(DHTMLPopupWithMoire.prototype);

BasicLightbox.prototype.init = function( popupId, closeBtnId, moireDivId )
{
    DHTMLPopupWithMoire.call( this, popupId, moireDivId);

    if(this.exist_invalid_fields_message_key == null || this.close_tab_confirmation_message_key == null){
        throw "not initialized constants in child class";
    }

    var self = this;

    this.hideOnMouseDown = function() { return false; };
    this.hideOnResize = function() { return false; };
    this.hideOnEscape = function() { return false; };
    this.onEscape = function() { this.cancel(); };

    this.lightBoxEl = this.getPopupEl()[0];
    this.innerContent = this.getPopupEl().find('.innerContent');

    this._errorMessageBox = this.getPopupEl().find('.errorMessageBox')
    this.removeErrorInFooter();
    this._validateCallback = function ()
    {
        if( self.hasErrors() )
            return;
        self.removeErrorInFooter();
    };


    this.closeButton = this.getCloseButtonEl(closeBtnId)

    if(this.closeButton)
    {
        this.closeButton.onclick = function() { self.cancel(); };
    }
    this._cancelEnabled = true;
    this._commitEnabled = true;

    this.commitButton = this.getCommitButtonEl();
    this.cancelButton = this.getCancelButtonEl();

    if (this.commitButton)
        this.commitButton.onclick = function() {
        self.commit()
    };
    else
        this._commitEnabled = false;

    if (this.cancelButton)
        this.cancelButton.onclick = function() {
        self.cancel()
    };

    this.successCallback = null;
    this.cancelCallback = null;

    // Callback to do some action after fail validate
    this.failureValidateCallback = null;

    this.footerEl = this.getFooterEl();
    
    if (this.footerEl) 
    {
        this.footerClassName = "basicLightboxFooter";
        this.footerEl.className = this.footerClassName;
    }

    return this;
};

BasicLightbox.prototype.getCommitButtonEl = function() {
    return document.getElementById( this.popupId + "_commitBtn" )
}

BasicLightbox.prototype.getCancelButtonEl = function() {
    return document.getElementById( this.popupId + "_cancelBtn" );
}

BasicLightbox.prototype.getFooterEl = function()
{
    return document.getElementById( this.popupId + "_footer" );
};

BasicLightbox.prototype.getCloseButtonEl = function(id) {
    return document.getElementById(id)
}

BasicLightbox.prototype.show = function ()
{
    if (typeof(onloadLightbox) == 'function'){
        if (!onloadLightbox())
            return;
    }

    DHTMLPopupWithMoire.prototype.show.call( this );

    if( this.close_tab_confirmation_message_key )
    {
        var self = this;
        ExitConfirmationHandlersManager.setUpExitConfirmation( messageResource.getMessage( this.close_tab_confirmation_message_key ),
                                                               function ()
                                                               {
                                                                   return self.wereDataChanged();
                                                               }, false );
    }
};

BasicLightbox.prototype.hide = function ()
{

    if (typeof(onHideLightBox) == 'function'){
         this.lightBoxHideHandle()
    }
    ExitConfirmationHandlersManager.restoreExitConfirmation();
    DHTMLPopupWithMoire.prototype.hide.call( this );
};

BasicLightbox.prototype.toggle = function (toggle)
{
    if (toggle) {
        this.show()
    } else {
        this.hide()
    }
}


BasicLightbox.prototype.lightBoxHideHandle = function ()
{
    onHideLightBox();
}

BasicLightbox.prototype.disableUserInputWhileSaving = function ()
{
    $( this.lightBoxEl ).addClass( "savingState" );
    this.disableButtons();
};

BasicLightbox.prototype.enableUserInputWhileSaving = function ()
{
    $( this.lightBoxEl ).removeClass( "savingState" );
    this.enableButtons();
};

BasicLightbox.prototype.setSuccessCallback = function( successCallback )
{
    this.successCallback = successCallback;
};

BasicLightbox.prototype.setFailureValidateCallback = function( failureValidateCallback )
{
    this.failureValidateCallback = failureValidateCallback;
};

BasicLightbox.prototype.setCancelCallback = function( cancelCallback )
{
    this.cancelCallback = cancelCallback;
};

BasicLightbox.prototype.updateUI = function ()
{
    // abstract
};

BasicLightbox.prototype.validate = function ()
{
    // abstract
};

BasicLightbox.prototype.cancel = function()
{
    if( this._cancelEnabled && (!this.wereDataChanged() || this.confirmCancelModifications()) )
        if( this.cancelCallback )
            this.cancelCallback();
};

BasicLightbox.prototype.getErrorsMap = function()
{
    //abstract
};

BasicLightbox.prototype.setErrorClasses = function( classes )
{
    //abstract
};

BasicLightbox.prototype.hasErrors = function()
{
    var classes = [];
    var errorsMap = this.getErrorsMap();
    for( var p in errorsMap )
        if( errorsMap[p] )
            classes.push( p );

    this.setErrorClasses( classes );
    return classes.length > 0;
};

BasicLightbox.prototype.commit = function()
{
    if ( !this._commitEnabled )
        return;

    var valid = this.validate();
    this.updateUI();
    if( this.hasErrors() ) {
        this.printErrorInFooter( messageResource.getMessage( this.exist_invalid_fields_message_key ) );
        this.failureValidateCallback && this.failureValidateCallback();
    }
    this._blinkErrorInFooter();
    if( valid && this.successCallback )
    {
        var inputData = this.getDataToCommit();
        this.successCallback.apply( this, inputData );
    }
};

BasicLightbox.prototype.getDataToCommit = function()
{
    // subclasses of BasicLightbox should override this method, if they need to collect data for applying to successCallback
    // (or they can collect it inside successCallback function instead)
    // if we return undefined or null, it will cause errors in IE8
    return [];
};

BasicLightbox.prototype.changesDetected = function()
{
};

BasicLightbox.prototype.wereDataChanged = function()
{
    return this.dataChanged;
};

BasicLightbox.prototype.confirmCancelModifications = function ()
{
    return confirm( messageResource.getMessage( this.cancel_confirmation_message_key ) );
};

BasicLightbox.prototype.printErrorInFooter = function ( error )
{
    this._errorMessageBox.find( ".errormsg" ).text( error );
    this._errorMessageBox.removeClass( "disabled" );
};

BasicLightbox.prototype.displayErrorInFooter = function ( error )
{
    this._errorMessageBox.removeClass( "disabled" );
};

BasicLightbox.prototype.removeErrorInFooter = function ()
{
    this._errorMessageBox.addClass( "disabled" );
};

BasicLightbox.prototype._hasErrorInFooter = function ()
{
    return !this._errorMessageBox.hasClass( "disabled" );
};

BasicLightbox.prototype._blinkErrorInFooter = function ()
{
    this._errorMessageBox.addClass( "blinkDisabled" );
    var self = this;
    window.setTimeout( function ()
                       {
                           self._errorMessageBox.removeClass( "blinkDisabled" );
                       }, 250 );
};

BasicLightbox.prototype.setDeleteButtonVisibility = function ( visible )
{
    this.deleteButton.style.visibility = visible ? "visible" : "hidden";
};

BasicLightbox.prototype.disableButtons = function ()
{
    this._cancelEnabled = false;
    this._commitEnabled = false;
};

BasicLightbox.prototype.enableButtons = function ()
{
    this._cancelEnabled = true;
    this._commitEnabled = true;
};

BasicLightbox.prototype.setCommitButtonTitle = function(title, defaultMessage, maxLength )
{
   this.setTextForElement(this.commitButtonTitlePlaceholder, title, defaultMessage, maxLength);
};

// function to set value for input text fields with placeholder
BasicLightbox.prototype.changesCallback = function()
{
    this.changesDetected();
};

// function to set value for input text fields with placeholder
BasicLightbox.prototype.setValue = function( field, value )
{
    field.removeClass('placeholder'); // IE8 doesn't switch placeholder class when field value is set
    field[0].value = value;
    field[0].prevValue = field[0].value;
};

BasicLightbox.prototype.basicOnKeyPressedHandler = function () {
    this.keyPressed = true;
};

BasicLightbox.prototype.basicKeyUpChangesHandler = function(additionalHandler) {
    var self = this;
    return function () {
        this.keyPressed = false;
        if( (!this.prevValue && !!this.value) || this.prevValue != this.value )
            self.changesCallback();

        if( additionalHandler )
            additionalHandler();
    }
};

BasicLightbox.prototype.scrollToSection = function(sectionEl)
{
    var correction = this.getContentOffset ? this.getContentOffset() : 0;
    this.innerContent.animate( { scrollTop: this.innerContent.scrollTop() + sectionEl.position().top + correction } );
};

BasicLightbox.prototype.basicOnBlurFieldHandler = function(additionalHandler){
    var self = this;
    return function()
    {
        $(this).pVal( trim(this.value) );
        //see Bug 48539
        if ( this.keyPressed ) self.basicKeyUpChangesHandler.call(this);

        if (additionalHandler)
            additionalHandler();
    };
};

BasicLightbox.prototype.checkEmpty = function ( field, errorCode, onlyRemoveEmptyError, hasPlaceholder )
{
    var errorsMap = this.getErrorsMap();
    if( !hasPlaceholder ? field.value.length == 0 : field.pVal().length == 0 )
    {
        if( !onlyRemoveEmptyError )
        {
            errorsMap[ errorCode ] = true;
        }
    }
    else
    {
        errorsMap[ errorCode ] = false;
    }
    return errorsMap[ errorCode ];
};

BasicLightbox.prototype.setTextForElement = function(element, title, defaultMessage, maxLength )
{
    if (defaultMessage){
        if (!maxLength) maxLength = 16;
        if (title.length > maxLength) {
            $(element).text( defaultMessage );
        }
        else
            $(element).text( title );

    }else{
        $(element).text( title );
    }
};

export default BasicLightbox



// WEBPACK FOOTER //
// ./web/js/BasicLightbox.js